/**
 * Default: Modules / Audiobook > Predefined filter
 */

import SelectorEngine from '../../../../shared/dom/selector-engine';
import EventHandler from '../../../../shared/dom/event-handler';
import Data from '../../../../shared/dom/data';
import Manipulator from '../../../../shared/dom/manipulator';

import Spinner from '../../../../shared/components/spinner';

let discoverToggles;
let discoverForm;
let controlSetFilter;
let tagRemoveFilter;

const handleDiscoverToggles = (loading) => {
	if (discoverToggles) {
		for (const ctrl of discoverToggles) {
			if (loading) {
				ctrl.dataset.loading = 'true';
			} else {
				delete ctrl.dataset.loading;
			}
		}
	}
};

const parseControlFilterData = (ctrl) => {
	let ctrlFilterString = ctrl.dataset.setFilter ?? null;

	ctrlFilterString = ctrlFilterString.replaceAll('\'','"');

	return JSON.parse(`{${ctrlFilterString}}`);
};

const setupDiscoverForm = () => {
	/*if (noUiSlider !== undefined) {
		const rangeCollection = SelectorEngine.find('input[type="range"]', discoverForm);

		for(const range of rangeCollection) {
			const rangeContainer = SelectorEngine.parents(range, '.form-range-container');
			const rangeSlider = Manipulator.elementAfter('<div class="form-range-slider"></div>', (rangeContainer[0] ?? range));

			const min = Number.parseFloat((range.getAttribute('min') ?? 1));
			const max = Number.parseFloat((range.getAttribute('max') ?? 10));
			const step = Number.parseFloat((range.getAttribute('step') ?? 0.1));

			let value =  ((min + max) / 2);

			if (range.value && range.value !== '') {
				value = Number.parseFloat(range.value);
			}

			Manipulator.addClass((rangeContainer[0] ?? range), '_visually-hidden');

			noUiSlider.create(rangeSlider, {
				start: [((min + max) / 2), value],
				behaviour: 'unconstrained',
				connect: true,
				// tooltips: true,
				tooltips: {
					to: function (val) {
						return val.toFixed(1);
					}
				},
				range: {
					'min': min,
					'max': max
				}//,
				// step: step
			});

			rangeSlider.noUiSlider.on('change', function () {
				const val = rangeSlider.noUiSlider.get(true);

				range.setAttribute('value', val[1].toFixed(1));
			});

			Data.set(range, 'rangeSlider', rangeSlider);
		}
	}*/

	//
	// Verfügbare Filterelemente initialisieren.
	//

	const formFields = SelectorEngine.find('input[type="checkbox"], input[type="range"], input[type="select"]', discoverForm);

	for (const field of formFields) {
		// Filterelement: Reset-Event.
		EventHandler.on(field, 'reset.discoverForm', (event) => {
			switch (event.target.type) {
				case 'checkbox': {
					event.target.checked = false;
					break;
				}

				case 'range': {
					const valMin   = Number.parseFloat((event.target.getAttribute('min') ?? 1));
					const valMax   = Number.parseFloat((event.target.getAttribute('max') ?? 10));

					let valReset = (valMin + valMax) / 2;

					if (event.target.dataset.resetValue && event.target.dataset.resetValue !== '') {
						valReset = Number.parseFloat(event.target.dataset.resetValue);
					}

					// Update Range-Slider
					const rangeSlider = Data.get(event.target, 'rangeSlider');

					event.target.setAttribute('value', valReset);

					if (rangeSlider) {
						rangeSlider.noUiSlider.set([null, valReset]);
					}

					break;
				}

				case 'select': {
					const options = SelectorEngine.find('option', event.target);

					options[0].selected = 'selected';
					break;
				}
			}

			if (event.doSubmit) {
				discoverForm.submit();
			} else {
				handleDiscoverToggles(false);
			}
		});
	}

	EventHandler.on(discoverForm, 'reset.discoverForm', (event) => {
		for (const field of formFields) {
			EventHandler.trigger(field, 'reset.discoverForm', {
				doSubmit: event.doSubmit ?? false
			});
		}
	});

	//
	// Formularevents
	//

	// ... Filter aktualisieren.
	EventHandler.on(discoverForm, 'updateFilter.discoverForm', (event) => {
		let doSubmit = false;

		EventHandler.trigger(discoverForm, 'reset.discoverForm', {
			doSubmit: false
		});

		handleDiscoverToggles(true);

		if (event.updateFilter && (event.updateFilter.range || event.updateFilter.categories || event.updateFilter.pathway)) {
			const hiddenPathway = SelectorEngine.findOne(`input[type="hidden"][data-ident="pathway"]`, discoverForm);

			if (hiddenPathway) {
				hiddenPathway.value = (event.updateFilter.pathway) ?? '';
			}

			if (event.updateFilter.categories) {
				const keys = Object.keys(event.updateFilter.categories);

				for (const ident of keys) {
					const target = SelectorEngine.findOne(`input[type="checkbox"][data-ident="${ident}"]`, discoverForm);

					if (target) {
						target.checked = true;

						doSubmit = true;
					}
				}
			}

			if (event.updateFilter.range) {
				const keys = Object.keys(event.updateFilter.range);

				for (const ident of keys) {
					const target = SelectorEngine.findOne(`input[type="range"][data-ident="${ident}"]`, discoverForm);

					if (target) {
						const val = Number.parseFloat(event.updateFilter.range[ident]);
						const rangeSlider = Data.get(target, 'rangeSlider');

						target.setAttribute('value', val);

						if (rangeSlider) {
							rangeSlider.noUiSlider.set([null, val]);
						}

						doSubmit = true;
					}
				}
			}
		}

		if (doSubmit) {
			discoverForm.submit();
		} else {
			handleDiscoverToggles(false);
		}
	});

	// ... Filter entfernen.
	EventHandler.on(discoverForm, 'removeFilter.discoverForm', (event) => {
		// Status ´loading´ der Discover-Toggles aktivieren.
		handleDiscoverToggles(true);

		const element = event.filter ? SelectorEngine.findOne(`[data-ident="${event.filter}"]`, discoverForm) ?? null : null;

		if (element) {
			// Ist das Filterelement vorhanden, Reset-Event triggern.
			EventHandler.trigger(element, 'reset.discoverForm', {
				doSubmit: event.doSubmit ?? false
			});
		} else {
			// Status ´loading´ der Discover-Toggles deaktivieren
			handleDiscoverToggles(false);
		}
	});

	//
	// Externe Steuerelemente
	//

	// ... Filter aktualisieren.
	if (controlSetFilter) {
		for (const ctrl of controlSetFilter) {
			const data = parseControlFilterData(ctrl);

			if (Object.keys(data).length > 0) {
				EventHandler.on(ctrl, `click.setFilter`, (event) => {
					event.preventDefault();
					event.stopPropagation();

					Spinner.addTo(ctrl);

					ctrl.dataset.loading = '';

					EventHandler.trigger(discoverForm, 'updateFilter.discoverForm', {
						updateFilter: data
					});
				});
			} else {
				Manipulator.setDisabled(ctrl);
			}
		}
	}

	// ... Filter entfernen.
	if (tagRemoveFilter) {
		for (const tag of tagRemoveFilter) {
			const target = tag.dataset.target ?? '';

			if (target) {
				// Da die Elemente zum Entfernen eines Filters ´Tags´ mit dem Attribut `data-removable` sind, reicht
				// die Anbindung des nachfolgenden Custom-Events aus. Dieses Event wird seitens `data-removable`
				// getriggert.
				EventHandler.on(tag, `will-removed.ifab.tag`, (event) => {
					EventHandler.trigger(discoverForm, 'removeFilter.discoverForm', {
						doSubmit: true,
						filter  : target
					});
				});
			} else {
				tag.remove();
			}
		}
	}
};

// --------
// Let's go
// --------

document.addEventListener('DOMContentLoaded', function () {
	discoverForm = SelectorEngine.findOne('form[data-form="discover-filter"]') ?? null;

	if (discoverForm) {
		discoverToggles = SelectorEngine.find('[aria-controls="discover-drawer"]') ?? null;
		controlSetFilter = SelectorEngine.find('button[data-set-filter]') ?? null;
		tagRemoveFilter = SelectorEngine.find('[data-tag="discover-filter-remove"]') ?? null;

		setupDiscoverForm();
	}
});
